import React from 'react'

interface TipBoxProps {
  message: string | React.ReactNode
  className?: string
}

const TipBox: React.FC<TipBoxProps> = ({ message, className = '' }) => {
  return (
    <div
      className={`tw-flex tw-items-center tw-gap-3 tw-p-4 tw-bg-[#FFF3C6] tw-border tw-border-[#F5B800] tw-rounded-lg tw-w-full tw-text-left ${className}`}
    >
      <div className="tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#F5B800] tw-text-white tw-font-bold tw-text-xs tw-leading-none tw-flex-shrink-0 tw-mt-[1px]">
        !
      </div>
      <div className="tw-flex-1">
        {typeof message === 'string' ? (
          <p className="tw-text-[15px] tw-leading-relaxed tw-text-[#0B1242] tw-m-0">
            {message}
          </p>
        ) : (
          <div className="tw-text-[15px] tw-leading-relaxed tw-text-[#0B1242]">
            {message}
          </div>
        )}
      </div>
    </div>
  )
}

export default TipBox
